import React from "react";
import { BsPersonStanding } from "react-icons/bs";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const Card = ({ data }) => {
  return (
    <div className="border border-gray-400 md:p-8 sm:p-[24px] p-[10px] flex items-stretch sm:gap-8 gap-4 md:w-1/2 w-full bg-white hover:shadow-md transition-shadow">
      <div className="flex-1 flex flex-col justify-between items-start sm:min-h-[180px]">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-3">
            <span className="p-2 rounded-full bg-[#E8F5F1] flex items-center justify-center shrink-0">
              <BsPersonStanding size={24} className="text-[#3AAA90]" />
            </span>
            <h2 className="sm:text-xl text-lg font-bold text-gray-900 leading-tight">
              {data?.name}
            </h2>
          </div>
          <div className="sm:text-sm text-xs font-normal !text-gray-700 !leading-relaxed sm:mb-4 mb-2">
            {data?.description?.length > 100
              ? data?.description?.slice(0, 100) + "..."
              : data?.description}
          </div>
        </div>
        <Link
          to={`/programDetail/${data?.id}`}
          className="text-[#3AAA90] font-semibold font-quicksand flex items-center gap-2 hover:gap-3 transition-all text-sm mt-auto"
        >
          Find out more <FaArrowRight size={14} />
        </Link>
      </div>
      <div className="sm:max-w-[45%] max-w-[35%] sm:w-full w-full ">
        <img
          src={data?.thumbnail[0]?.file}
          alt={data?.name}
          className="w-full sm:h-[180px] h-[140px] object-cover rounded"
        />
      </div>
    </div>
  );
};

export default Card;